import { post } from 'src/tools/server';
//portal/stockSupplier
const addUnit = (body) => {
  return post(`/portal/measurementUnit`, body, {});
};
export { addUnit };
